// extracted by mini-css-extract-plugin
export default {"container":"ControlPanel_container__HwFs4"};